import { render, staticRenderFns } from "./MemberPrize.vue?vue&type=template&id=5a127f5c&scoped=true&"
import script from "./MemberPrize.vue?vue&type=script&lang=js&"
export * from "./MemberPrize.vue?vue&type=script&lang=js&"
import style0 from "./MemberPrize.vue?vue&type=style&index=0&id=5a127f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a127f5c",
  null
  
)

export default component.exports